import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel } from '@fortawesome/free-regular-svg-icons';
import { faGear } from '@fortawesome/free-solid-svg-icons';
import Thead from '../../../../../../core/components/table-components/Thead';
import Tr from '../../../../../../core/components/table-components/Tr';
import ThWithControls from '../../../../../../core/components/table-components/ThWithControls';
import { useAppDispatch, useAppSelector } from '../../../../../../store/hooks';
import {
  reportIsVisibleSelector,
  salesOffsiteWorkingFiltersSelector,
} from '../../../../../../store/selectors/reportsSelectors';
import { setSalesOffsiteWorkingFilters } from '../../../../../../store/slices/reportsSlice';
import {
  getSalesOffsiteWorkingReportExcelThunk,
  getSalesOffsiteWorkingReportThunk,
} from '../../../../../../store/thunks/reports/reportsThunks';
import { SearchTableFilterType } from '../../../../../../core/types/coreTypes';
import Dropdown from '../../../../../../core/components/dropdown/Dropdown';
import ThNew from '../../../../../../core/components/table-components/table-new/ThNew';
import { ReportTableColumns } from '../../../../../types/RectificationReportsTypes';
import { useSalesOffsiteWorkingRanges } from '../../../../../hooks/useSalesOffsiteWorkingRanges';

const SalesOffsiteWorkingColumns: React.FC<ReportTableColumns> = ({ columns, totalCount }) => {
  const dispatch = useAppDispatch();
  const filters = useAppSelector(salesOffsiteWorkingFiltersSelector);
  const reportIsVisible = useAppSelector(reportIsVisibleSelector);

  const [searchVl, setSearchVl] = useState<SearchTableFilterType>({
    address: filters.address,
    cityTown: filters.cityTown,
    postalCode: filters.postalCode,
  });

  const { range, rangePatterns, setRange } = useSalesOffsiteWorkingRanges();

  const sortHandle = (field: number) => {
    const newFilters = {
      ...filters,
      order: filters.order?.field === field
        ? { ...filters.order, isAsc: !filters.order.isAsc }
        : { field, isAsc: false },
    };
    dispatch(setSalesOffsiteWorkingFilters(newFilters));
    dispatch(getSalesOffsiteWorkingReportThunk({ filters: newFilters }));
  };

  const onChangeSearchHandle = (v: string, field: string) => {
    setSearchVl({ ...searchVl, [field]: v });
    if (!v) {
      const newFilters = { ...filters, [field]: undefined };
      dispatch(setSalesOffsiteWorkingFilters(newFilters));
      dispatch(getSalesOffsiteWorkingReportThunk({ filters: newFilters }));
    }
  };
  const searchPressHandle = (field: string) => {
    const newFilters = { ...filters, [field]: searchVl[field]?.trim(), page: 1 };
    dispatch(setSalesOffsiteWorkingFilters(newFilters));
    dispatch(getSalesOffsiteWorkingReportThunk({ filters: newFilters }));
  };

  const setRangeHandle = (field: string, value: [number, number]) => {
    const [min, max] = value;
    const newFilters = {
      ...filters,
      [field]: { min, max },
      page: 1,
    };
    dispatch(setSalesOffsiteWorkingFilters(newFilters));
    dispatch(getSalesOffsiteWorkingReportThunk({ filters: newFilters }));
  };

  const exportToExcel = () => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { page, pageSize, ...rest } = filters;
    dispatch(getSalesOffsiteWorkingReportExcelThunk({ filters: rest }));
  };

  return (
    <Thead>
      <Tr>
        {columns.map((col) => (
          <ThWithControls
            key={col.dataIndex}
            col={col}
            tableFilters={filters}
            sortHandle={sortHandle}
            searchVl={searchVl}
            onChangeSearchHandle={onChangeSearchHandle}
            searchPressHandle={searchPressHandle}
            setRangeHandle={setRangeHandle}
            range={range}
            rangePatterns={rangePatterns}
            setRange={setRange}
            totalElements={totalCount}
            className={`salesOffsiteWorkingTh--${col.dataIndex}`}
            disabledFilter={!reportIsVisible}
          />
        ))}
        <ThNew action>
          <Dropdown
            disabled={!totalCount}
            menuItems={[
              {
                label: 'Export to Excel',
                icon: <FontAwesomeIcon icon={faFileExcel} />,
                key: 'export-to-excel',
                onClick: exportToExcel,
              },
            ]}
            icon={<FontAwesomeIcon icon={faGear} />}
          />
        </ThNew>
      </Tr>
    </Thead>
  );
};

export default SalesOffsiteWorkingColumns;
